import * as Types from '../../../generated/graphql.types';

import gql from 'graphql-tag';
import { UserPreviewFragmentDoc } from '../../_shared/fragments.generated';
import * as Urql from 'urql';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateUserMutationVariables = Types.Exact<{
  input: Types.CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'MutationRoot', createUser: { __typename?: 'CreateUserPayload', password?: string | null, error?: string | null } };

export type MyUserGroupQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MyUserGroupQuery = { __typename?: 'QueryRoot', myUserGroup: { __typename?: 'UserGroup', name: string, users: Array<{ __typename?: 'User', id: string, name: string }> } };


export const CreateUserDocument = gql`
    mutation createUser($input: CreateUserInput!) {
  createUser(input: $input) {
    password
    error
  }
}
    `;

export function useCreateUserMutation() {
  return Urql.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument);
};
export const MyUserGroupDocument = gql`
    query myUserGroup {
  myUserGroup {
    name
    users {
      ...UserPreview
    }
  }
}
    ${UserPreviewFragmentDoc}`;

export function useMyUserGroupQuery(options?: Omit<Urql.UseQueryArgs<MyUserGroupQueryVariables>, 'query'>) {
  return Urql.useQuery<MyUserGroupQuery, MyUserGroupQueryVariables>({ query: MyUserGroupDocument, ...options });
};

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateUserMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ createUser })
 *   )
 * })
 */
export const mockCreateUserMutation = (resolver: ResponseResolver<GraphQLRequest<CreateUserMutationVariables>, GraphQLContext<CreateUserMutation>, any>) =>
  graphql.mutation<CreateUserMutation, CreateUserMutationVariables>(
    'createUser',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMyUserGroupQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ myUserGroup })
 *   )
 * })
 */
export const mockMyUserGroupQuery = (resolver: ResponseResolver<GraphQLRequest<MyUserGroupQueryVariables>, GraphQLContext<MyUserGroupQuery>, any>) =>
  graphql.query<MyUserGroupQuery, MyUserGroupQueryVariables>(
    'myUserGroup',
    resolver
  )
